var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topnav-wrap"},_vm._l((_vm.topnavList),function(item,index){return _c('div',{key:index,staticClass:"topnav-item flc",class:{'active-item':_vm.currentIndex == index},on:{"click":function($event){return _vm.topnacChange(index)}}},[_vm._v(_vm._s(item.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }